import React, {Component} from 'react';
import {
  Container,
  Divider,
  Grid,
  Header,
  Image,
}                         from 'semantic-ui-react';
import _                  from 'lodash';
import ReactHtmlParser    from 'react-html-parser';
import PropTypes          from 'prop-types';
// import {isMobile}         from 'react-device-detect';

// Global
import getMessage         from '../../global/getMessage';
// Controller
import globalController   from '../../global/globalcontroller';
// Images
import gbacademyLogo      from '../../images/GB-academy-logo-white.png';
// Style
import                    '../MainStyle/MainTwo.scss';
import                    './MainGbAcademy.scss';

const propTypes = {
  content : PropTypes.arrayOf(PropTypes.object),
  lang    : PropTypes.shape({menu: PropTypes.object}),
};
const defaultProps = {
  content : null,
  lang    : {},
};

class MainGbAcademy extends Component {

  constructor(props) {
    super(props);

    this.state = {active: 0};

    this.handleItemCLick = this.handleItemCLick.bind(this);
  }

  handleItemCLick(e,v) {
    this.setState({active: v.index});
  }

  render() {
    const {lang} = this.props;
    const contentMsg = this.props.content || getMessage('section.gbacademy.content', lang);
    const content2Msg = this.props.content || getMessage('section.gbacademy.content2', lang);
    const content3Msg = this.props.content || getMessage('section.gbacademy.content3', lang);
    // const content4Msg = this.props.content || getMessage('section.gbacademy.content4', lang);

    const img2Msg = this.props.content || getMessage('section.gbacademy.img2', lang, true);
    const img3Msg = this.props.content || getMessage('section.gbacademy.img3', lang, true);
    // const img4Msg = this.props.content || getMessage('section.gbacademy.img4', lang, true);

    const contentHeader = [];
    const content2 = [];
    const content3 = [];
    // const content4 = [];

    _.forOwn(contentMsg, (value, key) => {
      contentHeader.push(
        <p key={key}>
          {value}
        </p>
      );
    });
    _.forOwn(content2Msg, (value, key) => {
      content2.push(
        <p key={key}>
          {value}
        </p>
      );
    });
    _.forOwn(content3Msg, (value, key) => {
      content3.push(
        <p key={key}>
          {value}
        </p>
      );
    });
    // _.forOwn(content4Msg, (value, key) => {
    //   content4.push(
    //     <p key={key}>
    //       {value}
    //     </p>
    //   );
    // });

    return (
      <Container className='sgr-mainHome-grid-two-sub main-gbacademy'>

        <Divider hidden />

        <Header
          as='h2'
          color='grey'
          inverted
          textAlign='center'
        >
          <Header.Content>

            <Image
              avatar
              size='small'
              src={gbacademyLogo}
            />
            {ReactHtmlParser(getMessage('menu.lesson.content', lang))}
          </Header.Content>
        </Header>

        {contentHeader}

        <Divider hidden />
        <Divider hidden />

        {content2}

        <Grid
          className='Main-GBAcademy-grid'
          columns={2}
          container
          stackable
        >
          {
            img2Msg && img2Msg.map((cnt, idx) => (
              <Grid.Column key={idx}>
                <a href={cnt.link}>
                  <Image
                    alt={cnt.alt}
                    src={`images/${cnt.img}`}
                  />
                </a>
              </Grid.Column>
            ))
          }
        </Grid>

        <Divider hidden />
        <Divider hidden />

        {content3}

        <Grid
          className='Main-GBAcademy-grid'
          columns={2}
          container
          stackable
        >
          {
            img3Msg && img3Msg.map((cnt, idx) => (
              <Grid.Column key={idx}>
                <a href={cnt.link}>
                  <Image
                    alt={cnt.alt}
                    src={`images/${cnt.img}`}
                  />
                </a>
              </Grid.Column>
            ))
          }
        </Grid>

        <Divider hidden />
        <Divider hidden />

        {/* {content4}*/}

        {/* <Grid*/}
        {/*  className='Main-GBAcademy-grid'*/}
        {/*  columns={2}*/}
        {/*  container*/}
        {/*  stackable*/}
        {/* >*/}
        {/*  {*/}
        {/*    img4Msg && img4Msg.map((cnt, idx) => (*/}
        {/*      <Grid.Column key={idx}>*/}
        {/*        <a href={cnt.link}>*/}
        {/*          <Image*/}
        {/*            alt={cnt.alt}*/}
        {/*            src={`images/${cnt.img}`}*/}
        {/*          />*/}
        {/*        </a>*/}
        {/*      </Grid.Column>*/}
        {/*    ))*/}
        {/*  }*/}
        {/* </Grid>*/}

      </Container>
    );
  }

}

MainGbAcademy.propTypes = propTypes;
MainGbAcademy.defaultProps = defaultProps;

export default globalController(MainGbAcademy);



// WEBPACK FOOTER //
// ./src/organisms/MainGbAcademy/MainGbAcademy.js